import React from 'react';
import parsePath from 'parse-filepath';

export const ResponsiveImage = ({ image, title, className, sizes }) => {
  // taking a base file name
  // let image = 'https://cdn.shopify.com/s/files/1/1425/9574/products/One-Of-…ind-Mexico-The-Perfect-Bag-Medium-No.-36242.jpg?v=1590081513';
  if (!image || typeof image !== 'string') {
    return null;
  }

  // we start by splitting the file into its components
  let mediaParts = parsePath(image);
  let baseUrl = mediaParts.dir;
  let baseName = mediaParts.name;
  let extension = mediaParts.ext;

  return (
    <img
      src={`${baseUrl}/${baseName}_100x${extension}`}
      srcSet={`${baseUrl}/${baseName}_100x${extension} 100w,
        ${baseUrl}/${baseName}_200x${extension} 200w,
        ${baseUrl}/${baseName}_400x${extension} 400w,
        ${baseUrl}/${baseName}_600x${extension} 600w,
        ${baseUrl}/${baseName}_1200x${extension} 1200w,
        ${baseUrl}/${baseName}_1800x${extension} 1800w
      `}
      width={image.width}
      height={image.height}
      alt={title}
      sizes={sizes}
      loading="lazy"
      className={className ? className : ''}
    ></img>
  );
};

export default ResponsiveImage;
